import { useEffect, useState } from "react";
import axios from "axios";

function ReviewCouponsStep({
  eodIds,
  onNext,
  onBack,
  url,
  setBarcodes,
  setSubmissionId,
  setTotalCouponsCost
}) {
  const [data, setData] = useState(null);
  

  useEffect(async () => {
    const params = { eodIds: eodIds };
    await axios
      .post(`${url}/coupons/getBarcodes`, params)
      .then((res) => setData(res.data))
      .catch((error) => {
        console.log("Fetch error", error);
      });
  }, [eodIds]);

  const handleNextStep = async () => {
    const allBarcodes = data.reduce((acc, eod) => acc.concat(eod.barcodes), []);
    const totalSalesAmount = data.reduce((sum, eod) => {
      return sum + eod.sales.reduce((eodSum, sale) => eodSum + Number(sale.amount), 0);
    }, 0);

    setTotalCouponsCost(totalSalesAmount)
    setBarcodes(allBarcodes);

    try {
      let params = { eod_ids: eodIds };
      await axios
        .post(`${url}/coupons/submissions/draft`, params)
        .then((res) => {
          setSubmissionId(res.data.submission_id);
          onNext();
        });
    } catch (err) {
      console.error("Submission error:", err);
      alert("Failed to start Menzies submission: " + err.message);
    }
  };

  if (!data) return <p>Loading...</p>;

  return (
    <div className="menzies-wizard">
      <h2>Step 2: Review Coupons</h2>
      {data.map((eod, index) => (
        <div key={index}>
          <p>
            EOD ID: {eod.eodId}, Sales: {eod.saleCount}, Barcodes:{" "}
            {eod.barcodeCount}, Missing: {eod.missingCount}
          </p>
          <div className="tables-box">
            <table>
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Staff</th>
                  <th>Till</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {eod.sales.map((sale, i) => (
                  <tr key={i}>
                    <td>{new Date(sale.time).toLocaleString()}</td>
                    <td>{sale.staff}</td>
                    <td>{sale.till}</td>
                    <td>£{sale.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th>Barcode</th>
                </tr>
              </thead>
              <tbody>
                {eod.barcodes.map((barcode, i) => (
                  <tr key={i}>
                    {barcode.imgFormat ? <td>{barcode.imgFormat}</td> : null}
                    {barcode.image ? <td>{barcode.image}</td> : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      <div className="button-group">
        <button className="btn" onClick={onBack}>
          ← Back
        </button>
        <button className="btn" onClick={handleNextStep}>
          Continue
        </button>
      </div>
    </div>
  );
}
export default ReviewCouponsStep;
